import { Stream } from 'interfaces'
import CuratedFolderViewNavigation from './CuratedFolderViewNavigation'
import styles from './CuratedFolderViewHeader.pcss'
import { FilterType } from 'shared'

export type CuratedFolderHeaderProps = {
  stream: Stream,
  navigation: CuratedFolderViewNavigation,
  expandedView?: boolean
  onFilterChange?(filter: FilterType): void
  onBackClick?(): void
}

function CuratedFolderViewHeader(props: CuratedFolderHeaderProps) {
  const { stream, navigation, onBackClick, expandedView } = props

  return (
    <header className={`${styles.header} ${expandedView ? styles.expanded : ''}`} data-test="curated-folder-view-header">
      <h2 className={`${styles.title} text-ellipsis`}>{stream.title}</h2>
      <a className={`${styles.navigation} hidden-mobile`} onClick={onBackClick}>{navigation.back}</a>
    </header>
  )
}

export default CuratedFolderViewHeader
